import React, { useEffect, useState } from 'react';
import { tl } from '../../utils/inlineI18n';
import { loadSocketConfig, stoneImageUrl, isEnglish } from '../../utils/socketConfig';
import '../sockets/Sockets.css';

// Wiki: soket, değerli taş, rune ve kombinasyonlar. Oranlar sadece sunucu izin verirse (geliştirici modu / test hesabı) gelir.
const WikiSocketPanel = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    loadSocketConfig(true).then(setCfg);
  }, []);
  if (!cfg) return <p>{tl('Yükleniyor…', 'Loading…')}</p>;
  const en = isEnglish();
  const levelNames = (en ? cfg.levelNamesEn : cfg.levelNames) || [];
  const stoneName = (s) => (en ? s.nameEn : s.name);
  const label = (s) => (en ? s.labelEn : s.label);
  const tokenImg = (token, i) => {
    const s = token.startsWith('rune:')
      ? cfg.stones.find((x) => x.kind === 'rune' && x.key === token.slice(5))
      : cfg.stones.find((x) => x.kind === 'gem' && x.color === token);
    return s ? <img key={i} src={stoneImageUrl(s, 1)} alt={stoneName(s)} title={stoneName(s)} /> : token;
  };
  const effLabel = (eff) => {
    const s = cfg.stones.find((x) => x.effect === eff);
    return s ? label(s) : eff;
  };
  const group = (kind) => cfg.stones.filter((s) => s.kind === kind);
  const r = cfg.rates;

  return (
    <div className="wiki-efsun-panels">
      <div className="wiki-efsun-panel">
        <h3>{tl('Soket Sistemi', 'Socket System')}</h3>
        <p>
          {tl(
            `Yeni düşen veya alınan silahlarda en fazla ${cfg.maxSockets?.weapon} soket, zırhlarda en fazla ${cfg.maxSockets?.armor} soket çıkabilir. Soketlere değerli taş veya rune takılır. Taşlar metin çekirdeklerinden, boss midelerinden ve nadiren canavarlardan düşer. Demircideki Taş Ustası'nda 3 aynı taş birleştirilerek bir üst seviye denenir ve taşlar soketlere takılır. Taşlar sırayla dizildiğinde kombinasyon bonusu verir.`,
            `New weapons may roll up to ${cfg.maxSockets?.weapon} sockets, armors up to ${cfg.maxSockets?.armor}. Sockets hold gems or runes. Stones drop from metin cores, boss stomachs and rarely from monsters. At the Blacksmith's Stone Master you can combine 3 identical stones into the next level and insert stones into sockets. Stones placed in sequence grant combo bonuses.`
          )}
        </p>
        <p>{tl('Seviyeler', 'Levels')}: {levelNames.join(' → ')}</p>
      </div>

      {['gem', 'rune'].map((kind) => (
        <div key={kind} className="wiki-efsun-panel">
          <h3>{kind === 'gem' ? tl('Değerli Taşlar', 'Gems') : tl('Rune\'lar', 'Runes')}</h3>
          <div className="wiki-efsun-table-wrap">
            <table className="wiki-efsun-table">
              <thead>
                <tr>
                  <th>{tl('Taş', 'Stone')}</th>
                  <th>{tl('Etki', 'Effect')}</th>
                  {levelNames.map((n) => <th key={n}>{n}</th>)}
                </tr>
              </thead>
              <tbody>
                {group(kind).map((s) => (
                  <tr key={s.key}>
                    <td><img src={stoneImageUrl(s, 2)} alt="" style={{ width: 24, height: 24, verticalAlign: 'middle' }} /> {stoneName(s)}</td>
                    <td>{label(s)}</td>
                    {s.values.map((v, i) => <td key={i}>+{v}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      <div className="wiki-efsun-panel">
        <h3>{tl('Kombinasyonlar', 'Combos')}</h3>
        <p className="socket-hint">{tl('Taşlar soketlerde art arda bu sırayla dizilmelidir.', 'Stones must be placed consecutively in this order.')}</p>
        {(cfg.combos || []).map((c) => (
          <div key={c.key} className="wiki-socket-combo">
            <strong>✨ {en ? c.nameEn : c.name}</strong>
            <span className="wiki-socket-pattern">{c.pattern.map(tokenImg)}</span>
            <div>{c.bonuses.map((b) => `${effLabel(b.type)} +${b.value}`).join(' · ')}</div>
          </div>
        ))}
      </div>

      {r ? (
        <div className="wiki-efsun-panel">
          <h3>🔧 {tl('Oranlar (geliştirici/test)', 'Rates (dev/test)')}</h3>
          <div className="wiki-socket-rates">
            <p>{tl('Birleştirme başarısı', 'Combine success')}: %{r.craftSuccessPercent} · {tl('Takma başarısı', 'Insert success')}: %{r.insertSuccessPercent}</p>
            <p>{tl('Canavardan taş', 'Monster stone')}: ‰{r.monsterStonePerMille}</p>
            <p>{tl('Metin çekirdeği', 'Metin core')}: {Object.entries(r.metinCore || {}).map(([k, v]) => `${k} %${v}`).join(' · ')}</p>
            <p>{tl('Boss midesi', 'Boss stomach')}: {Object.entries(r.bossStomach || {}).map(([k, v]) => `${k} %${v}`).join(' · ')}</p>
            {Object.entries(r.sockets || {}).map(([src, byType]) => (
              <div key={src}>
                <strong>{src === 'npc' ? tl('NPC\'den alınan', 'Bought from NPC') : tl('Düşen', 'Dropped')}</strong>
                {Object.entries(byType).map(([type, arr]) => (
                  <p key={type}>
                    {type}: {arr.map((pm, i) => `${i} ${tl('soket', 'socket')} %${(pm / 10).toFixed(1)}`).join(' · ')}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default WikiSocketPanel;
